// src/components/FloatingButtons.jsx
import React from "react";
import axios from "axios";
import ContactInfo from "../hooks/ContactInfo";
import useGeoInfo from "../useGeoInfo";

const FloatingButtons = () => {
  /* ------------ 1. ثابت المشروع ------------ */
  const account  = "Online";
  const platform = "Google";
  const server   = "https://system.yousrygroup.com/api_test/php/server.php"; // ← عدّل المسار لو API‑ك مختلف

  /* ------------ 2. جلب البيانات من الـ hooks ------------ */
  const contact = ContactInfo(account, platform); // ext, whats_call, phone_call, …
  const geo     = useGeoInfo();                   // ip, lat, lng, country, city, region

  /* انتظر وصول البيانات أولاً */
  if (!contact || !geo.ip) return null;

  /* ------------ 3. إعداد روابط واتساب و الاتصال ------------ */
  const welcomeMsg = encodeURIComponent(
    "Hello! I'm interested in joining your academy. Please share more details."
  );
  const whatsappHref = `https://wa.me/${contact.ext}${contact.whats_call}?text=${welcomeMsg}`;
  const callHref     = `tel:${contact.ext}${contact.phone_call}`;

  /* ------------ 4. تسجيل الضغطة فى قاعدة البيانات ------------ */
  const trackClick = (type /* 0 = WhatsApp, 1 = Call */) => {
    const fd = new FormData();
    fd.append("insert",      type);
    fd.append("account",     account);
    fd.append("platform",    platform);
    fd.append("platform_ip", geo.ip);
    fd.append("ip_lat",      geo.lat);
    fd.append("ip_lng",      geo.lng);
    fd.append("ip_country",  geo.country);
    fd.append("ip_city",     geo.city);
    fd.append("ip_region",   geo.region);

    axios.post(server, fd).catch((err) => console.error("Track error:", err));
  };

  /* ------------ 5. واجهة الأزرار العائمة ------------ */
  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right:  "20px",
        zIndex:  9999,
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      {/* WhatsApp */}
      <a
        href={whatsappHref}
        onClick={() => trackClick(0)}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: "#25D366",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          fontSize: "24px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
        title="WhatsApp"
      >
        <iconify-icon icon="ic:baseline-whatsapp"></iconify-icon>
      </a>

      {/* Call */}
      <a
        href={callHref}
        onClick={() => trackClick(1)}
        style={{
          backgroundColor: "#007bff",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          fontSize: "24px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
        title="Call Now"
      >
        <iconify-icon icon="ic:round-call"></iconify-icon>
      </a>
    </div>
  );
};

export default FloatingButtons;
